import { render, staticRenderFns } from "./LatestNews.vue?vue&type=template&id=529b6ee0&"
import script from "./LatestNews.vue?vue&type=script&lang=js&"
export * from "./LatestNews.vue?vue&type=script&lang=js&"
import style0 from "./LatestNews.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports